import LeadsTask from './LeadsTask'
export default LeadsTask
